import moment from 'moment';
import every from 'lodash/every';

import { enum as payoutStatuses } from '../../../../../../enums/payout-statuses';

function getMainPayoutAmount(item) {
	return item.partial_payouts.reduce((acc, v) => acc + v.amount, item.amount);
}

function getPayoutCommission(item) {
	const commission = (item.percent / 100) * item.amount;
	return item.allow_floats ? +commission.toFixed(2) : Math.floor(commission);
}

function getMainPayoutCommission(item) {
	return +item.partial_payouts
		.reduce((acc, v) => acc + getPayoutCommission(v), getPayoutCommission(item))
		.toFixed(2);
}

function getPayoutClosedAt(item, withStatus) {
	return item.status === withStatus ? moment(item.updated_at) : null;
}

function getPayoutPaidAt(item) {
	return getPayoutClosedAt(item, payoutStatuses.paid);
}

function getPayoutRejectedAt(item) {
	return getPayoutClosedAt(item, payoutStatuses.rejected);
}

function getMainPayoutStatus(item, statuses) {
	const isUndivided = !item.partial_payouts.length;
	const isEverythingPaid = every([item, ...item.partial_payouts], { status: payoutStatuses.paid });
	const status = isUndivided || isEverythingPaid ? item.status : payoutStatuses.partially;

	return statuses.find((s) => s.value === status);
}

function getPaidPayoutStatus(item, statuses) {
	return statuses.find((s) => s.value === item.status);
}

function getMainPayout(item, statuses) {
	return {
		isDivided: !!item.partial_payouts.length,
		currency: item.currency,
		created_at: moment(item.created_at),
		id: item.id,
		amount: getMainPayoutAmount(item),
		commission: getMainPayoutCommission(item),
		system: item.system,
		paid_at: getPayoutPaidAt(item),
		rejected_at: getPayoutRejectedAt(item),
		status: getMainPayoutStatus(item, statuses)
	};
}

function getPartPayout(item, statuses) {
	return {
		currency: item.currency,
		created_at: null,
		id: item.id,
		amount: item.amount,
		commission: getPayoutCommission(item),
		system: null,
		paid_at: getPayoutPaidAt(item),
		rejected_at: getPayoutRejectedAt(item),
		status: getPaidPayoutStatus(item, statuses)
	};
}

function getPartPayouts(item, statuses) {
	if (item.partial_payouts.length) {
		return [item, ...item.partial_payouts].map((part) => getPartPayout(part, statuses));
	}

	return [];
}

export default function formatPayouts(data, statuses) {
	return data.map((item) => ({
		payout: getMainPayout(item, statuses),
		children: getPartPayouts(item, statuses)
	}));
}


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/payout-table/format-payouts.js